export default __webpack_public_path__ + "static/bg-4-ee968222ee15b29f6e2c185872429eae.png";